// src/themes/highcharts-light-theme.js


const HighchartsLightTheme = {
  chart: {
    backgroundColor: '#FFFFFF',
    // height: 300,
    style: {
      fontFamily: 'Omnes-Regular, sans-serif',
    },
    plotBorderColor: '#CCC',
  },
  title: {
    style: {
      color: '#333333',
      textTransform: 'uppercase',
      fontSize: '0.72rem',
    },
    useHTML: true
  },
  subtitle: {
    style: {
      color: '#666666',
      textTransform: 'uppercase',
    },
  },
  xAxis: {
    gridLineColor: '#E6E6E6',
    labels: {
      style: {
        color: '#333333',
      },
    },
    lineColor: '#E6E6E6',
    minorGridLineColor: '#F0F0F0',
    tickColor: '#E6E6E6',
    title: {
      style: {
        // color: '#333333',
        color: "#2D787F",
        fontSize: '0.72rem',
      },
    },
  },
  yAxis: {
    gridLineColor: '#E6E6E6',
    labels: {
      style: {
        color: '#333333',
      },
    },
    lineColor: '#E6E6E6',
    minorGridLineColor: '#F0F0F0',
    tickColor: '#E6E6E6',
    tickWidth: 1,
    title: {
      style: {
        // color: '#333333',
        color: "#2D787F",
        fontSize: '0.72rem',
      },
    },
    lineWidth: 1,
  },
  tooltip: {
    backgroundColor: 'rgba(255, 255, 255, 0.85)',
    style: {
      color: '#333333',
    },
  },
  plotOptions: {
    series: {
      dataLabels: {
        color: '#333333',
      },
      marker: {
        lineColor: '#333',
      }
    },
    boxplot: {
      fillColor: '#E6E6E6',
    },
    candlestick: {
      lineColor: '#333',
    },
    errorbar: {
      color: '#333',
    },
  },
  legend: {
    itemStyle: {
      color: ' #333333',  // Dark gray color for text
      fontWeight: 'bold', // Bold text for better readability
    },
    itemHoverStyle: {
      color: '#000',  // Black color when hovered
    },
    itemHiddenStyle: {
      color: '#CCC',  // Light gray for hidden items
    },
    backgroundColor: 'rgba(255, 255, 255, 0.9)', // Semi-transparent white background
    borderColor: '#CCC',  // Light gray border color
    borderWidth: 1,  // Border width for the legend box
    shadow: false,  // No shadow for a flat design
  },
  credits: {
    style: {
      color: '#999',
    },
    enabled: false,
  },
  labels: {
    style: {
      color: '#666',
    },
  },
  drilldown: {
    activeAxisLabelStyle: {
      color: '#333333',
    },
    activeDataLabelStyle: {
      color: '#333333',
    },
  },
  navigation: {
    buttonOptions: {
      symbolStroke: '#333333',
      theme: {
        fill: '#F0F0F0',
      },
    },
  },
  rangeSelector: {
    buttonTheme: {
      fill: '#F0F0F0',
      stroke: '#CCC',
      style: {
        color: '#333',
      },
      states: {
        hover: {
          fill: '#E6E6E6',
          stroke: '#CCC',
          style: {
            color: '#000',
          },
        },
        select: {
          fill: '#D4D4D4',
          stroke: '#CCC',
          style: {
            color: '#000',
          },
        },
      },
    },
    inputBoxBorderColor: '#CCC',
    inputStyle: {
      backgroundColor: '#FFF',
      color: '#333',
    },
    labelStyle: {
      color: '#333',
    },
  },
  navigator: {
    handles: {
      backgroundColor: '#CCC',
      borderColor: '#AAA',
    },
    outlineColor: '#CCC',
    maskFill: 'rgba(255,255,255,0.1)',
    series: {
      color: '#7798BF',
      lineColor: '#A6C7ED',
    },
    xAxis: {
      gridLineColor: '#E6E6E6',
    },
  },
  scrollbar: {
    barBackgroundColor: '#DDD',
    barBorderColor: '#DDD',
    buttonArrowColor: '#333',
    buttonBackgroundColor: '#F0F0F0',
    buttonBorderColor: '#F0F0F0',
    rifleColor: '#333',
    trackBackgroundColor: '#F0F0F0',
    trackBorderColor: '#F0F0F0',
  },
};

export default HighchartsLightTheme;
